import { http } from '../http';

export interface Categoria {
  codigo_categoria: string;
  descricao_categoria: string;
  codigo_tipo_veiculo: string;
  valor_adesao: number;
  participacao_minima: number;
  porcentagem_fipe: number;
  situacao: string;
}

export interface CategoriaResponse {
  total: number;
  page: number;
  limit: number;
  items: Categoria[];
}

export const fetchSgaCategorias = async (
  codigoTipo?: string,
  page: number = 1,
  limit: number = 10,
  sortBy: string = 'descricao_categoria',
  sortOrder: 'asc' | 'desc' = 'asc'
): Promise<CategoriaResponse> => {
  const response = await http.get('/sga-categoria/listar', {
    params: {
      page,
      limit,
      sortBy,
      sortOrder,
      ...(codigoTipo ? { codigo_tipo_veiculo: codigoTipo } : {}),
    },
  });

  return response.data;
};
